import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  button: {
  },
  icon: {
    color: theme.palette.green.main,
  },
}));
